<template>
  <v-card color="kbWhite" class="elevation-0">
    <v-col cols="12" class="pa-4">
      <span class="kbDarkBlueText--text">{{$t('toolbar.notifications')}}</span>
    </v-col>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <div class="overflow-y-auto" style="max-height: 400px">
        <v-list color="kbWhite" v-if="lastAppNotifications.length === 0">
          <v-list-item>
            <v-list-item-avatar>
              <v-icon>check</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-subtitle>
                {{$t('toolbar.upToDateNotifications')}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-list two-line color="kbWhite" class="pa-0">
          <template v-for="notification in lastAppNotifications">
            <Notification :key="notification._id" :notification="notification"></Notification>
          </template>
        </v-list>
      </div>
      <v-divider></v-divider>
      <v-toolbar dense color="kbWhite">
        <v-btn color="kbDarkBlueText"
               block
               text
               class="ma-0"
               @click="goToAppNotifications">
          {{$t('general.seeAll')}}
        </v-btn>
      </v-toolbar>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import Notification from '@/components/widgets/list/Notification.vue'
export default {
  components: { Notification },
  computed: {
    ...mapState({
      lastAppNotifications: state => state.appNotifications.lastAppNotifications
    })
  },
  async created () {
    try {
      await this.$store.dispatch('getLastAppNotifications')
    } catch (e) { }
  },
  methods: {
    goToAppNotifications () {
      this.$router.push('/notifications')
      this.$emit('input', false)
    }
  }
}
</script>
